import React from 'react';
import { MarqueeBar } from './components/MarqueeBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { PricingSection } from './components/PricingSection';
import { CountdownTimer } from './components/CountdownTimer';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { OfferRecap } from './components/OfferRecap';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-[#00A86B] selection:text-white" data-id="element-0">
      <MarqueeBar data-id="element-1" />

      {/* Main content wrapper with top padding to offset the fixed marquee */}
      <main className="pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <ProductPresentation data-id="element-5" />
        <PricingSection data-id="element-6" />
        <CountdownTimer data-id="element-7" />
        <BonusSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <OfferRecap data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <FooterSection data-id="element-14" />
    </div>;
}